<template>
  <div class="list-group list-group-flush">
    <a
      v-for="filter in filters"
      :key="filter.id"
      class="list-group-item list-group-item-action d-flex align-items-center"
      :class="{ active: filter.id === selected }"
      href="#"
      @click.stop.prevent="action(filter.id)"
      @mouseout="hover_cancel(filter.id)"
      @mouseover="hover_start(filter.id)"
    >
      <icon v-if="filter.icon" class="me-1" :name="filter.icon" />
      <span v-html="filter.title" />
      <span
        v-if="filter.badge"
        class="position-absolute end-0 me-2 bg-light text-primary badge rounded-pill"
        v-html="filter.badge"
      />
      <icon v-else class="position-absolute end-0 me-2" name="CHEVRON_RIGHT" />
    </a>
  </div>
</template>

<script>
import icon from "@pdfking/workflow/components/icon"
import can_hover from "../../../features/can_hover"

export default {
  components: { icon },
  data() {
    return {
      hover: {},
    }
  },
  methods: {
    hover_cancel(id) {
      if (can_hover() && this.hover[id]) {
        clearTimeout(this.hover[id])
        delete this.hover[id]
      }
    },

    hover_start(id) {
      if (can_hover()) {
        this.hover_cancel(id)

        this.hover[id] = setTimeout(() => {
          this.hover_cancel(id)
          this.action(id)
        }, 200)
      }
    },
  },
  props: {
    action: {
      required: true,
      type: Function,
    },
    badge: {
      default: null,
      required: false,
      type: String,
    },
    filters: {
      default: () => [],
      required: false,
      type: Array,
    },
    selected: {
      default: null,
      type: String,
    },
  },
}
</script>
